import styled from 'styled-components';
export const PremiumBadge = styled.div``;
